import React from "react";

interface RadioButtonsProps {
  label?: string;
  value: string;
  options:
    | string[]
    | Array<{
        id: string;
        label: string;
        style?: { [attribute: string]: string };
      }>;
  onChange: (value: string) => void;
  className?: string;
  required?: boolean;
}

const RadioButtons: React.FC<RadioButtonsProps> = ({
  label,
  value,
  options,
  onChange,
  className = "",
  required = false,
}) => {
  const isObjectOptions = options.length > 0 && typeof options[0] === "object";

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {label && (
        <label className="text-sm font-medium text-gray-700">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div>
        {isObjectOptions
          ? (
              options as Array<{
                id: string;
                label: string;
                style?: { [attribute: string]: string };
              }>
            ).map((option) => (
              <div onClick={() => onChange(option.id)}>
                <input
                  type="radio"
                  id={option.label}
                  value={option.label}
                  onChange={() => onChange(option.id)}
                  checked={value === option.id}
                  className="mr-1"
                />
                <span className=" mb-1">{option.label}</span>
              </div>
            ))
          : (options as string[]).map((option) => (
              <div onClick={() => onChange(option)}>
                <input
                  type="radio"
                  id={option}
                  value={option}
                  onChange={() => onChange(option)}
                  checked={value === option}
                  className="mr-1"
                />
                <span className=" mb-1">{option}</span>
              </div>
            ))}
      </div>
    </div>
  );
};

export { RadioButtons };
